// extracted by mini-css-extract-plugin
export default {"link":"NavigBtn_link__6Fssj","active":"NavigBtn_active__MJ-iI"};